import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@/styles/reactnative";
import { TransferAmountAll } from "../styles";
import { ThemeContext } from "@/theme/ThemeProvider";
import styled from "styled-components";

const TransferAll = ({ balance, setAmount, coinType }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useContext(ThemeContext);
  
  return (
    <ModernTransferAmountAll>
      <AllButton
        isDarkMode={isDarkMode}
        onClick={() => {
          setAmount(balance >= 0.001 ? balance : 0);
        }}
      >
        {t("all")}
      </AllButton>
      <CoinTypeText isDarkMode={isDarkMode}>{coinType}</CoinTypeText>
    </ModernTransferAmountAll>
  );
};

// Styled Components
const ModernTransferAmountAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  z-index: 1002;
  pointer-events: all;
  position: relative;
`;

const AllButton = styled.button<{ isDarkMode: boolean }>`
  background: transparent;
  border: none;
  color: #FF5C17;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  pointer-events: all;
  z-index: 1003;
  position: relative;
  
  &:hover {
    background: rgba(255, 92, 23, 0.1);
    color: #FF8A50;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const CoinTypeText = styled.span<{ isDarkMode: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.isDarkMode ? '#FFFFFF' : '#E0E0E0'};
  opacity: 0.8;
`;

export default TransferAll;
